<template>
  <div>
    <div v-if="!fullWidth">
      <div :class="heroImageLink ? 'grid lg:grid-cols-2' : ''">
        <div>
          <span class="crumb" v-if="breadcrumbTitle">
            <Breadcrumb
              :category="breadcrumbCategoryTitle"
              :categoryLink="breadcrumbCategoryLink"
              :subcategory="breadcrumbSubcategoryTitle"
              :subcategoryLink="breadcrumbSubcategoryLink"
              :title="breadcrumbTitle"
              :titleLink="breadcrumbLink"
            />
          </span>
          <div :class="heroClass">
            <img
              v-if="iconLink"
              :src="iconLink" 
              :alt="iconAlt"
            />
            <h1 v-text="title"></h1>
            <slot></slot>
          </div>
          <div class="w-4/5 mx-auto">
            <div class="pt-3" v-html="text" />
          </div>
        </div>
        <div v-if="heroImageLink && isBasicImage">
          <img :src="heroImageLink" class="rounded-bl-3xl" align="right"/>
        </div>
        <div class="hero-top-half-width" :style="heroBg" v-if="heroImageLink && !isBasicImage">
          <div></div>
        </div>
      </div>
      <div class="hero-bottom-half-width" :style="heroBg" v-if="heroImageLink && !isBasicImage">
        <div class="bg-white curveTopRight"></div>
      </div>
    </div>

    <div v-else>
      <span class="crumb" v-if="breadcrumbTitle">
        <Breadcrumb
          :category="breadcrumbCategoryTitle"
          :categoryLink="breadcrumbCategoryLink"
          :title="breadcrumbTitle"
          :titleLink="breadcrumbLink"
        />
      </span>
      <div class="hero-top-full-width" :style="heroBg" style="padding: 60px 0; min-height: 300px;">
        <div class="hero-leaf" :class="heroClass">
          <img
            v-if="iconDetails && iconDetailsLink"
            :src="imageLocation + iconDetailsLink" 
            :alt="iconDetailsAlt"
          />
          <h1 v-html="title"></h1>
          <p class="clear-both" v-html="text" v-if="text"></p>
          <slot></slot>
        </div>
      </div>
      <!-- <div class="hero-bottom-full-width" :style="heroBg">
        <div class="white curveTopRight hidden md:block" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "breadcrumbCategoryTitle", 
    "breadcrumbCategoryLink", 
    "breadcrumbSubcategoryTitle", 
    "breadcrumbSubcategoryLink", 
    "breadcrumbTitle",
    "breadcrumbLink",
    "heroImageLink",
    "iconDetails",
    "iconDetailsLink",
    "iconLink",
    "iconAlt",
    "imageLocation",
    "title",
    "text",
    "color",
    "fullWidth",
    "isBasicImage"
  ],
  data() {
    return {
      heroClass: ""
    }
  },
  computed: {
    heroBg() {
      return {
        "background-image": this.heroImageLink ? "url('" + this.heroImageLink + "')" : "transparent;"
      }
    },
    centered() {
      return {
        "margin": "auto"
      }
    }
  },
  async mounted() {
    if (!this.fullWidth) {
      this.heroClass = this.color == "Red" || this.color == "red" || this.color == "orange" ? "hero-orange" : "hero-green";
      if (!this.heroImageLink) {
        this.heroClass += ' centered-hero';
      }
    } else {
      this.heroClass = this.color == "Red" || this.color == "red" || this.color == "orange" ? "hero-leaf-red" : "hero-leaf-green";
    }
  }
};
</script>

<style scoped>
.centered-hero {
  margin: auto !important;
}

.hero-top-half-width {
  background-cover: cover;
  border-bottom-left-radius: 70px;
  background-position: right bottom -70px;
  background-size: 804px auto;
  background-repeat: no-repeat;
}

.hero-bottom-half-width {
  background-cover: cover;
  background-size: 804px auto;
  background-position: right bottom;
  background-repeat: no-repeat;
  height: 70px;
}

.hero-top-full-width {
  /* background-position: right bottom -70px; */
  /* background-size: 1440px auto; */
  background-size: cover;
  border-bottom-left-radius: 70px;
  background-repeat: no-repeat;
}

.hero-bottom-full-width {
  background-size: 1440px auto;
  background-position: right bottom;
  background-repeat: no-repeat;
  height: 70px;
}

@media (max-width: 1200px) {
  .hero-bottom {
    width: 100%;
    height: auto !important;
  }
}

@media (max-width: 900px) {
  .hero-top {
    border-bottom-right-radius: 0;
  }

  .hero-bottom {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .hero-form input[type="text"] {
    width: auto;
  }

  .hero-leaf h1 {
    font-size: 1.5em;
  }
}
</style>
